import templateUrl from "./account-options.html"

export const AccountOptionsComponent = {
    controller: AccountOptionsController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        identity: "<"
    }
}

function AccountOptionsController($state, $window, sessionService, utilityService) {
    'ngInject'
    const vm = this;
    vm.handleLogoffClick = handleLogoffClick;
    vm.handleEndImpersonationClick = handleEndImpersonationClick;
    vm.identity;
    vm.state = $state;

    function handleLogoffClick() {
        sessionService.signOut()
    }

    function handleEndImpersonationClick() {
        utilityService.showLoading();
        sessionService.endProxy()
            .catch(() => {})
            .then(function() {
                utilityService.hideLoading();
                $window.location.href = "Home/Index"
            })
    }
}
